import React from 'react';
import { Container, Typography,  Grid, Box, Stack } from '@mui/material';


const AnimatedCodeEditor = () => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      bgcolor: '#1E293B',
      borderRadius: 2,
      p: 3,
      overflow: 'hidden',
      position: 'relative'
    }}
  >
    {/* Editor Header */}
    <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#EF4444' }} />
      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#F59E0B' }} />
      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#10B981' }} />
    </Stack>

    {/* Code Lines */}
    {[...Array(6)].map((_, index) => (
      <Box
        key={index}
        sx={{
          height: 20,
          mb: 1.5,
          bgcolor: '#ffffff',
          width: `${Math.random() * (85 - 50) + 50}%`,
          borderRadius: 1,
          animation: 'pulse 2s infinite',
          animationDelay: `${index * 0.2}s`,
          '@keyframes pulse': {
            '0%': { opacity: 0.3 },
            '50%': { opacity: 0.7 },
            '100%': { opacity: 0.3 }
          }
        }}
      />
    ))}

    {/* Typing Effect */}
    <Box
      sx={{
        mt: 4,
        height: 24,
        width: '70%',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          right: -12,
          top: 0,
          height: '100%',
          width: 2,
          bgcolor: '#3B82F6',
          animation: 'blink 1s infinite',
        },
        '@keyframes blink': {
          '50%': { opacity: 0 }
        }
      }}
    >
      <Typography
        sx={{
          color: '#3B82F6',
          fontFamily: 'monospace',
          fontSize: '1rem',
          animation: 'typing 3s steps(30, end) infinite',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          '@keyframes typing': {
            '0%': { width: '0%' },
            '50%': { width: '100%' },
            '100%': { width: '0%' }
          }
        }}
      >
        const future = await buildSoftware();
      </Typography>
    </Box>

    {/* Floating Elements */}
    {[...Array(5)].map((_, index) => (
      <Box
        key={index}
        sx={{
          position: 'absolute',
          width: 40,
          height: 40,
          borderRadius: 2,
          background: 'linear-gradient(45deg, #3B82F6 30%, #2563EB 90%)',
          opacity: 0.1,
          animation: 'float 3s infinite',
          animationDelay: `${index * 0.5}s`,
          top: `${Math.random() * 80}%`,
          left: `${Math.random() * 80}%`,
          '@keyframes float': {
            '0%, 100%': { transform: 'translateY(0)' },
            '50%': { transform: 'translateY(-20px)' }
          }
        }}
      />
    ))}
  </Box>
);

export const Hero: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        pt: 12,
        pb: 8,
       
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              component="h1"
              variant="h2"
              color="text.primary"
              gutterBottom
              fontWeight="bold"
            >
              Development Tools
              <br />
              <span style={{ color: '#2563eb' }}>For The Future</span>
            </Typography>
            <Typography variant="h6" color="text.secondary" paragraph>
              Streamline your development workflow with our powerful suite of tools
              and custom software solutions.
            </Typography>
            {/* <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
              <Button variant="contained" size="large">
                Get Started
              </Button>
              <Button variant="outlined" size="large">
                View Products
              </Button>
            </Box> */}
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                height: '400px',
                bgcolor: 'grey.100',
                borderRadius: 2,
                overflow: 'hidden'
              }}
            >
              <AnimatedCodeEditor />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};